import { useEffect, useMemo, useState } from 'react';
import { getPodcasts } from '../api/api';
import { getPodcastGraphic2Url, resolveContentMedia } from '../helper/graphic2';
import { HubFeatureCard } from '../layout/HubFeatureCard';
import { HubListingView } from '../layout/HubListingView';
import { usePaginatedItems } from '../layout/usePaginatedItems';

function parsePodcasts(podcasts) {
  return podcasts.map((pItem) => ({
    postId: pItem.id ?? pItem.Id,
    postType: pItem.ContentType,
    title: pItem.Title,
    postDate: pItem.DatePublished,
    postMedia: resolveContentMedia(pItem, getPodcastGraphic2Url),
    postName: pItem.Relevance,
    creator: pItem.Author,
    content: pItem.Description,
  }));
}

export function PodcastCardList() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const firstItem = items[0];
  const listItems = useMemo(() => items.slice(1), [items]);
  const { pageItems, totalPages, currentPage, onPageChange } = usePaginatedItems(listItems);

  useEffect(() => {
    const loadPodcasts = async () => {
      setLoading(true);
      try {
        const podcastRes = await getPodcasts();
        setItems(parsePodcasts(podcastRes));
      } catch {
        setItems([]);
      } finally {
        setLoading(false);
      }
    };

    loadPodcasts();
  }, []);

  const renderFeatured = (item) => <HubFeatureCard firstBlog={item} />;

  return (
    <HubListingView
      title="Podcasts"
      firstItem={firstItem}
      renderFeatured={renderFeatured}
      pageItems={pageItems}
      loading={loading}
      totalPages={totalPages}
      currentPage={currentPage}
      onPageChange={onPageChange}
    />
  );
}
